import { Stack, Skeleton } from '@mantine/core';
import GuestHash from '@projects/models/guestHash';
import useFetchGuestHashesForProjectQuery from '@projects/queries/useFetchGuestHashesForProjectQuery';

import Project from '../../../../../../entities/project';

import InviteLink from '../InviteLink/InviteLink';

export type InviteLinksProps = {
	project : Project;
	onInviteLinkChange?: ( guestHash: GuestHash ) => void;
};

const InviteLinks = ( { project, onInviteLinkChange }: InviteLinksProps ) => {
	const { data: guestHashes } = useFetchGuestHashesForProjectQuery( { projectID: project.id } );
	const skeletonCount = project.guestHashes?.length || 1;

	return (
		<Stack spacing={6}>
			{guestHashes && guestHashes.map( ( guestHash: GuestHash ) => (
				<InviteLink
					key={guestHash.id}
					guestHash={guestHash}
					projectID={project.id}
					onInviteLinkChange={onInviteLinkChange}
				/>
			) )}
			{!guestHashes && Array.from( { length: skeletonCount } ).map( () => (
				<Skeleton height={36} opacity={0.3} />
			) )}
		</Stack>
	);
};

export default InviteLinks;
